import {getRequest} from "./getRequest";

export const checkMaintenanceMode = async () => {
  try {
    const data = await getRequest(`${import.meta.env.VITE_API_ROOT}/check-maintenance`);

    if (data.isMaintenanceActive) {
      return Promise.resolve(true);
    } else {
      return Promise.resolve(false);
    }
  } catch (error) {
    return Promise.resolve(true);
  }
};
